import { render, staticRenderFns } from "./FacilityCreate.vue?vue&type=template&id=220e9214&scoped=true&"
import script from "./FacilityCreate.vue?vue&type=script&lang=js&"
export * from "./FacilityCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220e9214",
  null
  
)

export default component.exports